import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from './auth/AuthContext';
import { ExperiencesProvider } from './context/ExperiencesContext';
import { SavedProvider } from './context/SavedContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <ExperiencesProvider>
        <SavedProvider>
          <App />
        </SavedProvider>
      </ExperiencesProvider>
    </AuthProvider>
  </React.StrictMode>
);